import openConfirmationPanel from './openConfirmationPanel'
import { getAssetUrlInWorker } from '../getAssetUrl'
import type { EditorSDK, Logger } from '@wix/wix-data-client-common-standalone'

export const openGenericConfirmationPanel = async ({
  editorSdkProxy,
  logger,
  t,
  headerText,
  descriptionText,
  mainActionText,
}: {
  editorSdkProxy: EditorSDK
  logger: Logger
  t: (key: string) => string
  headerText?: string
  descriptionText?: string
  mainActionText?: string
}) => {
  const panelTexts = {
    headerText: t('Workspace_Error_Panel_Title_General'),
    descriptionText: t('Workspace_Error_Panel_Text_General'),
    mainActionText: t('Workspace_Error_Panel_Button'),
  }

  openConfirmationPanel({
    editorSdkProxy,
    logger,
    illustration: await getAssetUrlInWorker(
      editorSdkProxy,
      'panel-icons/generic_error.svg',
    ),
    headerText: headerText || panelTexts.headerText,
    descriptionText: descriptionText || panelTexts.descriptionText,
    mainActionText: mainActionText || panelTexts.mainActionText,
  })
}
